import { useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const WorkshopsDialog = ({ open, workshops, isAdmin, onClose, onChanged }) => {
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const add = async () => {
    try { await api.post("/fleet/workshops", { name, location }); setName(""); setLocation(""); toast.success("Officina aggiunta"); onChanged(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (w) => {
    if (!window.confirm(`Eliminare l'officina ${w.name}?`)) return;
    try { await api.delete(`/fleet/workshops/${w.id}`); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto" data-testid="workshops-dialog">
        <DialogHeader><DialogTitle>Officine</DialogTitle></DialogHeader>
        <div className="flex flex-col gap-2 sm:flex-row">
          <Input placeholder="Nome officina" value={name} onChange={(e) => setName(e.target.value)} data-testid="workshop-name-input" />
          <Input placeholder="Luogo (facoltativo)" value={location} onChange={(e) => setLocation(e.target.value)} data-testid="workshop-location-input" />
          <Button onClick={add} disabled={!name.trim()} data-testid="workshop-add-button"><Plus className="h-4 w-4" /></Button>
        </div>
        <ul className="divide-y rounded-lg border">
          {workshops.map((w) => (
            <li key={w.id} className="flex items-center justify-between px-3 py-2 text-sm" data-testid={`workshop-item-${w.id}`}>
              <span><b className="font-medium">{w.name}</b>{w.location && <span className="text-slate-500"> · {w.location}</span>}</span>
              {isAdmin && <Button size="sm" variant="ghost" className="text-slate-400" onClick={() => remove(w)} data-testid={`workshop-delete-${w.id}`}><Trash2 className="h-4 w-4" /></Button>}
            </li>
          ))}
          {workshops.length === 0 && <li className="px-3 py-6 text-center text-sm text-slate-400">Nessuna officina</li>}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
